var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('v-card',{staticStyle:{"border-radius":"0","max-width":"1000px"},attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("Страница не найдена")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }